import {
  Data,
  notesContainerParams,
  RespNotesContainerInterface,
  RespNotesContainerModel,
} from "./Models/NotesContainer.model";
import { apiService } from "../../../../../../../../services/apiService";
import { apiServiceConstants } from "../../../../../../../../constants";
import { utilService } from "../../../../../../../../services/utilService";
import {
  notesCardParams,
  RespNotesCardInterface,
  RespNotesCardModel,
} from "./components/NotesCard/Models/NotesCard.model";
import {
  updatedNotesCardParams,
  RespUpdatedNotesCardInterface,
  RespUpdatedNotesCardModel,
} from "./components/NotesCard/Models/UpdatedNotesCard.model";

const getNotesContainerList = async (
  params: notesContainerParams
): Promise<RespNotesContainerInterface> => {
  const respApiResult = await apiService
    .apiCall(
      `sboard/unit/note/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const notesContainerResp = res as RespNotesContainerModel;
      const notesContainerResponse = setNotesContainerModel(notesContainerResp);
      const result: RespNotesContainerInterface = {
        isSuccess: notesContainerResp.isSuccess,
        displayNotesContainer: notesContainerResponse,
        status: notesContainerResp.status,
        message: notesContainerResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: RespNotesContainerInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
        displayNotesContainer: [],
      };
      return result;
    });

  return respApiResult;
};

const addNotesCardList = async (
  params: notesCardParams
): Promise<RespNotesCardInterface> => {
  const respApiResult = await apiService
    .apiCall(
      `sboard/unit/note/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const notesCardResp = res as RespNotesCardModel;
      const notesCardResponse = setNotesCardsModel(notesCardResp);
      const result: RespNotesCardInterface = {
        isSuccess: notesCardResp.isSuccess,
        displayNotesCard: notesCardResponse,
        status: notesCardResp.status,
        message: notesCardResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: RespNotesCardInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });
  return respApiResult;
};

const getUpdatedNotesCardList = async (
  params: updatedNotesCardParams
): Promise<RespUpdatedNotesCardInterface> => {
  const respApiResult = await apiService
    .apiCall(
      `sboard/unit/note/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const updatedNotesCardResp = res as RespUpdatedNotesCardModel;
      const updatedNotesCardResponse =
        setUpdatedNotesCardsModel(updatedNotesCardResp);
      const result: RespUpdatedNotesCardInterface = {
        isSuccess: updatedNotesCardResp.isSuccess,
        displayUpdatedNotesCard: updatedNotesCardResponse,
        status: updatedNotesCardResponse.status,
        message: updatedNotesCardResponse.message,
      };
      return result;
    })
    .catch((err) => {
      const result: RespUpdatedNotesCardInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const setNotesContainerModel = (payload: RespNotesContainerModel): any => {
  let NotesContainerListArray = payload.result?.map((object: any) => {
    return {
      count: object.count,
      next: object.next,
      previous: object.previous,
      data: mapData(object.data),
    };
  });

  return NotesContainerListArray;
};

const mapData = (groupData: Array<Data>): any => {
  let NotesDataListArray = groupData.map((object: any) => {
    return {
      id: object.id,
      userName: object.user_name,
      dateTime: object.date_time,
      note: object.note,
    };
  });

  return NotesDataListArray;
};

const setNotesCardsModel = (payload: RespNotesCardModel): any => {
  let NotesCardListArray = payload.result?.map((object: any) => {
    return {
      id: object.id,
      userName: object.user_name,
      dateTime: object.date_time,
      note: object.note,
    };
  });
  return NotesCardListArray;
};

const setUpdatedNotesCardsModel = (payload: RespUpdatedNotesCardModel): any => {
  let UpdatedNotesContainerListArray = payload.result?.map((object: any) => {
    return {
      id: object.id,
      userName: object.user_name,
      dateTime: object.date_time,
      note: object.note,
    };
  });

  return UpdatedNotesContainerListArray;
};

const handleErrorResponse = () => {};

export const notesContainerService = {
  getNotesContainerList,
  addNotesCardList,
  getUpdatedNotesCardList,
  handleErrorResponse,
};
